import revive_payload_client_4sVQNw7RlN from "/builds/RunRepeat/rr_front/node_modules/nuxt/dist/app/plugins/revive-payload.client.js";
import unhead_KgADcZ0jPj from "/builds/RunRepeat/rr_front/node_modules/nuxt/dist/head/runtime/plugins/unhead.js";
import router_jmwsqit4Rs from "/builds/RunRepeat/rr_front/node_modules/nuxt/dist/pages/runtime/plugins/router.js";
import payload_client_yVLowv6hDl from "/builds/RunRepeat/rr_front/node_modules/nuxt/dist/app/plugins/payload.client.js";
import navigation_repaint_client_bs2bWDGRIE from "/builds/RunRepeat/rr_front/node_modules/nuxt/dist/app/plugins/navigation-repaint.client.js";
import check_outdated_build_client_8vK7RkfGxZ from "/builds/RunRepeat/rr_front/node_modules/nuxt/dist/app/plugins/check-outdated-build.client.js";
import chunk_reload_client_UciE0i6zes from "/builds/RunRepeat/rr_front/node_modules/nuxt/dist/app/plugins/chunk-reload.client.js";
import plugin_vue3_YdLad5Mpq3 from "/builds/RunRepeat/rr_front/node_modules/@pinia/nuxt/dist/runtime/plugin.vue3.js";
import components_plugin_KR1HBZs4kY from "/builds/RunRepeat/rr_front/.nuxt/components.plugin.mjs";
import prefetch_client_5tzzN0oIVL from "/builds/RunRepeat/rr_front/node_modules/nuxt/dist/pages/runtime/plugins/prefetch.client.js";
import sentry_client_VdOeuw25Mb from "/builds/RunRepeat/rr_front/node_modules/@sentry/nuxt/build/module/runtime/plugins/sentry.client.js";
import sentry_client_config_o34nk2sJbg from "/builds/RunRepeat/rr_front/.nuxt/sentry-client-config.mjs";
import switch_locale_path_ssr_8BKffvaEi5 from "/builds/RunRepeat/rr_front/node_modules/@nuxtjs/i18n/dist/runtime/plugins/switch-locale-path-ssr.mjs";
import i18n_yfWm7jX06p from "/builds/RunRepeat/rr_front/node_modules/@nuxtjs/i18n/dist/runtime/plugins/i18n.mjs";
import plugin_t2GMTTFnMT from "/builds/RunRepeat/rr_front/node_modules/@nuxtjs/device/dist/runtime/plugin.mjs";
import _04_experiment_client_4g62Ohp9tQ from "/builds/RunRepeat/rr_front/plugins/04.experiment.client.js";
import _06_vue_gtag_client_3CHNWHpITI from "/builds/RunRepeat/rr_front/plugins/06.vue-gtag.client.js";
import _07_ga_events_8eJ4jsiCAl from "/builds/RunRepeat/rr_front/plugins/07.ga-events.js";
import directives_GDwrTGmylM from "/builds/RunRepeat/rr_front/plugins/directives.js";
import filters_znakZuvLqA from "/builds/RunRepeat/rr_front/plugins/filters.js";
import global_components_6g9ZiColWR from "/builds/RunRepeat/rr_front/plugins/global-components.js";
import routerScrollBehavior_iEvuhgaF6J from "/builds/RunRepeat/rr_front/plugins/routerScrollBehavior.js";
export default [
  revive_payload_client_4sVQNw7RlN,
  unhead_KgADcZ0jPj,
  router_jmwsqit4Rs,
  payload_client_yVLowv6hDl,
  navigation_repaint_client_bs2bWDGRIE,
  check_outdated_build_client_8vK7RkfGxZ,
  chunk_reload_client_UciE0i6zes,
  plugin_vue3_YdLad5Mpq3,
  components_plugin_KR1HBZs4kY,
  prefetch_client_5tzzN0oIVL,
  sentry_client_VdOeuw25Mb,
  sentry_client_config_o34nk2sJbg,
  switch_locale_path_ssr_8BKffvaEi5,
  i18n_yfWm7jX06p,
  plugin_t2GMTTFnMT,
  _04_experiment_client_4g62Ohp9tQ,
  _06_vue_gtag_client_3CHNWHpITI,
  _07_ga_events_8eJ4jsiCAl,
  directives_GDwrTGmylM,
  filters_znakZuvLqA,
  global_components_6g9ZiColWR,
  routerScrollBehavior_iEvuhgaF6J
]